import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { debounce } from 'lodash'

import { useFormik } from 'formik'
import { ApplicationState } from '@/state/root.models'
import { SportsROFilters } from '@/state/sports-ro-calculator/models'

import {
  useSportsROCalculatorActions,
  initialValuesSportsRO,
  validationSchemaSportsRO,
} from './'

export const useSportsROCalculatorFilters = () => {
  const { pagination, filters } = useSelector(
    ({ sportsRO }: ApplicationState) => sportsRO,
  )

  const formikSportsRO = useFormik({
    initialValues: initialValuesSportsRO,
    validationSchema: validationSchemaSportsRO,
    onSubmit: () => {},
    enableReinitialize: true,
  })

  const { getAllSportsROCalculator, setSportsROCalculatorFilters } =
    useSportsROCalculatorActions()

  // eslint-disable-next-line
  const filterDelay = useCallback(
    debounce((newFilters: Partial<SportsROFilters>) => {
      getAllSportsROCalculator(newFilters)
    }, 500),
    [],
  )

  const handleChangeSearch = (field: string, value: any) => {
    setSportsROCalculatorFilters({
      ...filters,
      [field]: value,
      page: 1,
    })
    formikSportsRO.setFieldValue(field, value)
  }

  const handleChangePage = (newPage: number) => {
    setSportsROCalculatorFilters({ ...filters, page: newPage })
    getAllSportsROCalculator({ ...filters, page: newPage })
  }

  const handleChangeLimit = (newLimit: number) => {
    if (Math.ceil(pagination.total / newLimit) < (filters.page || 1)) {
      setSportsROCalculatorFilters({
        ...filters,
        limit: newLimit,
        page: 1,
      })
      getAllSportsROCalculator({
        ...filters,
        limit: newLimit,
        page: 1,
      })
    } else {
      setSportsROCalculatorFilters({ ...filters, limit: newLimit })
      getAllSportsROCalculator({ ...filters, limit: newLimit })
    }
  }

  const submitSearchFilter = () => {
    getAllSportsROCalculator(filters)
  }

  return {
    filters,
    formikSportsRO,
    handleChangeSearch,
    handleChangePage,
    handleChangeLimit,
    submitSearchFilter,
  }
}
